import { FC } from "react";
import { useTypedSelector } from "../../hooks/useTypedSelector";
import { getCurrentUser } from "../../store/authSlice";
import getInitialsName from "../../utils/getInitialsName";
import { icons } from "../../icons/IconSet";
import DropMenu from "../common/dropmenu/DropMenu";
import { useAuth } from "../../hooks/useAuth";
import UserLogoutBtn from "./UserLogoutBtn";
import Truncate from "../common/Truncate";
import { useLocation, useNavigate } from "react-router-dom";

const UserWidget: FC = () => {
  const user = useTypedSelector(getCurrentUser());
  const navigate = useNavigate();
  const { handleLogout } = useAuth();
  const { pathname } = useLocation();

  return (
    <div className="flex gap-4 items-center h-full">
      <div
        tabIndex={-1}
        role="button"
        onClick={() => navigate('/account')}
        className={`
          flex gap-4 h-full justify-between items-center hover:text-primary px-4
          ${pathname === '/account'
            ? 'text-primary no-underline border-b-white bg-gradient-to-b from-transparent to-white'
            : ' border-b-transparent'}
        `}
      >
        <div className="flex w-[35px] h-[35px] min-w-[35px] bg-gray-400 rounded-lg items-center justify-center text-white font-semibold tracking-wide">
          {getInitialsName(user?.name)}
        </div>
        <div className="grid overflow-hidden">
          <div className="truncate">{user?.name ?? 'Nameless'}</div>
          <div className="truncate opacity-80">
            <Truncate>
              {user?.email ?? ''}
            </Truncate>
          </div>
        </div>       
        {/* <div className="flex items-center">
          <DropMenu
            width="238px"
            top="36px"
            right="-47px"
            icon={icons('chevron-down', { width: '18px' })}
            links={[
              { name: 'Account', to: `http://localhost:3000/users/${user?.id}`  },
              {},
              { name: 'Log Out', onClick: handleLogout },
            ]}
          />
        </div> */}
      </div>
      <UserLogoutBtn />
    </div>
  );
};

export default UserWidget;
